import React, { useRef,useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import {onAuthStateChanged} from "firebase/auth";
import {auth} from "../../firebase-config";
import {db} from "../../firebase-config";
import {app} from "../../firebase-config";
import { async } from '@firebase/util';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, Firestore, query, where } from "firebase/firestore";
import Cookies from 'universal-cookie';
import Modal from 'react-modal';
import DatePicker, { setDefaultLocale } from "react-datepicker";
import Moment from 'moment';
import Wait from '../../resources/wait.gif';
import { Alert } from 'react-bootstrap';
import  MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import  '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import $ from 'jquery';
import './Geocoder.css';

MapboxGeocoder.accessToken = 'pk.eyJ1Ijoib21hcmVuZXplYWxlIiwiYSI6ImNrNjZ6MDd3NzAwNmQzbG4xc3cwczI4Z3MifQ.v-bx7nRll5E2xUgM_FalHg';
const geocoder = new MapboxGeocoder({
    accessToken: MapboxGeocoder.accessToken,
    types: 'address',
    placeholder: "Start typing to search address.",
    // bbox: [-122.182768,37.259244,-121.538695,37.558133]
});


const MapAdd = (props) => {
    const [Address,setAddress] = useState(props.club.Address);
    const [City,setCity] = useState(props.club.City);
    const [State,setState] = useState(props.club.State);
    const [ZIP,setZIP] = useState(props.club.ZIP);
    const [isLoadingAdd,setIsLoadingAdd] = useState(false);


    const mapContainerRef = useRef(null);
    // const [mapObject, setMap] = useState();
    const [mymap, setMymap] = useState();
    const [lat,setLat] = useState(props.club.lat);
    const [lng,setLng] = useState(props.club.lng);

    // setZIP("123");
    // console.log(ZIP);


    useEffect(() => {
        $('#geocoder').html("");
        geocoder.addTo('#geocoder');  
        const results = document.getElementById('result');
          // Add geocoder result to container.

        geocoder.on('result', (e) => {
            var jsondata = JSON.parse(JSON.stringify(e.result, null, 2));
            setLng(jsondata.geometry.coordinates[0]);
            setLat(jsondata.geometry.coordinates[1]);
            var data = e.result.place_name.split(",");
            var data2 = data[2].split(" ");
            setAddress(data[0].trim());
            setCity(data[1].trim());
            setState(data2[1].trim());
            setZIP(data2[2].trim());
            // console.log(JSON.parse(JSON.stringify(e.result, null, 2)));
            // setMapCenter2([jsondata.geometry.coordinates[0],jsondata.geometry.coordinates[1]])
            // results.innerText = JSON.stringify(e.result, null, 2);
            // alert(JSON.stringify(e.result, null, 2));
            // var jsondata = JSON.parse(JSON.stringify(e.result, null, 2));
            // props.simplifiedFunction(jsondata.center[0],jsondata.center[1]);
        });
        
        // Clear results container when search is cleared.
        geocoder.on('clear', () => {
            // results.innerText = '';
        });

    }, []);

    const updateAddress = async () => {
        // alert(props.club.id);return;
        if(Address.length<=0){
            alert("Please insert address to update...");
            return;
        }
        setIsLoadingAdd(true);
        const userDoc = doc(db, "clubs", props.club.id);
        var date = new Date();
        const newFields = { 
            date_modified:date,
            by: props.username + " " + props.lastname,
            Address:Address,
            City:City,
            State:State,
            ZIP:ZIP,
            lat:lat,
            lng:lng,
        };
        await updateDoc(userDoc, newFields).then(()=>{
            props.getClubs();
            setIsLoadingAdd(false);
            props.closeModal2();
        });
    }

    return (
        <div className='row'>
           
           <div className='col-lg-12'>
                name: <b>{props.club.club_name}</b>
           </div>

            <div className='col-lg-12'>
                <div id="geocoder"></div>
            </div>
            <div className='col-lg-6'>
                <label>Address</label>
                <input type="text" id="programname" className='form-control' value={Address}
                onChange={(event)=>{setAddress(event.target.value)}} readOnly='yes'></input>
            </div>
            <div className='col-lg-2'>
                <label>City</label>
                <input type="text" id="programname" className='form-control' value={City}
                onChange={(event)=>{setCity(event.target.value)}} readOnly='yes'></input>
            </div>
            <div className='col-lg-2'>
                <label>State</label>
                <input type="text" id="programname" className='form-control' value={State}
                onChange={(event)=>{setState(event.target.value)}} readOnly='yes'></input>
            </div>
            <div className='col-lg-2'>
                <label>Zip</label>
                <input type="text" id="programname" className='form-control' value={ZIP}
                onChange={(event)=>{setZIP(event.target.value)}} readOnly='yes'></input>
            </div>
            <div className='col-lg-12'>
                <button className='btn btn-sm btn-success' onClick={updateAddress}>Save</button>
                <button className='btn btn-danger btn-sm' id="close_modal" onClick={props.closeModal2}>Cancel</button>
            </div>
            <div className='col-lg-12'>
                {isLoadingAdd?<div><img src={Wait} alt="Ball" width="25px" />Processing, please wait...</div>:""}
            </div>
           <br></br>
        </div>
    )
}

export default MapAdd;